import React, { useState, useEffect } from 'react';
import AffirmationCard from './components/AffirmationCard';
import { AFFIRMATIONS, PERSONALIZED_AFFIRMATIONS } from './affirmations';
import './App.css';

const App = () => {
  const [currentAffirmation, setCurrentAffirmation] = useState('');
  const [userName, setUserName] = useState('');
  const [fadeIn, setFadeIn] = useState(false);

  // Get name from URL query params on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const name = params.get('name');
    if (name) {
      setUserName(name);
    }
  }, []);

  // Set initial affirmation
  useEffect(() => {
    getNewAffirmation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);

  const getNewAffirmation = () => {
    setFadeIn(false);
    setTimeout(() => {
      // Check if user has personalized affirmations
      const normalizedName = userName.toLowerCase();
      let affirmationPool = [...AFFIRMATIONS];
      
      // If this person has personalized affirmations, add them to the pool
      if (PERSONALIZED_AFFIRMATIONS[normalizedName]) {
        affirmationPool = [...affirmationPool, ...PERSONALIZED_AFFIRMATIONS[normalizedName]];
      }
      
      const randomIndex = Math.floor(Math.random() * affirmationPool.length);
      setCurrentAffirmation(affirmationPool[randomIndex]);
      setFadeIn(true);
    }, 300);
  };

  return (
    <div className="app-container">
      <div className="background-gradient"></div>
      <div className="stars"></div>
      
      <header className="app-header">
        <h1 className="app-title">Affirmations (from Sneha)</h1>
        <p className="app-subtitle">Notes of positivity, written by Sneha</p>
        <p className="app-subtitle">(yes, she wrote every single line, no AI was used, these are her words lol)</p>
      </header>

      <main className="main-content">
        <div className={`affirmation-container ${fadeIn ? 'fade-in' : 'fade-out'}`}>
          <AffirmationCard affirmation={currentAffirmation} userName={userName} />
        </div>

        <button className="new-affirmation-btn" onClick={getNewAffirmation}>
          <span className="btn-text">New Affirmation</span>
          <span className="btn-shine"></span>
        </button>
      </main>

      <footer className="app-footer">
        <p>✨ breathe & take a moment to believe in yourself ✨</p>
      </footer>
    </div>
  );
};

export default App;